// Utility to dynamically update favicon and page title
export const updateFaviconAndTitle = (logoUrl, shopName) => {
  // Update page title
  if (shopName) {
    document.title = `${shopName}`;
  } else {
    document.title = 'Cafe WebReady24 - Multi-Restaurant Food Ordering';
  }

  // Update favicon
  updateFavicon(logoUrl);
};

export const updateFavicon = (logoUrl) => {
  // Remove existing dynamic favicon if any
  const existingFavicon = document.getElementById('dynamic-favicon');
  if (existingFavicon) {
    existingFavicon.remove();
  }

  // If no logo URL, use default favicon
  if (!logoUrl) {
    setDefaultFavicon();
    return;
  }

  // Create new favicon link
  const favicon = document.createElement('link');
  favicon.id = 'dynamic-favicon';
  favicon.rel = 'icon';
  favicon.type = 'image/x-icon';
  favicon.href = logoUrl;

  // Add to document head
  document.head.appendChild(favicon);
};

export const setDefaultFavicon = () => {
  // Remove dynamic favicon
  const existingFavicon = document.getElementById('dynamic-favicon');
  if (existingFavicon) {
    existingFavicon.remove();
  }

  // Set default favicon (you can change this to your preferred default)
  const defaultFavicon = document.querySelector("link[rel*='icon']") || document.createElement('link');
  defaultFavicon.rel = 'icon';
  defaultFavicon.type = 'image/x-icon';
  defaultFavicon.href = '/web.png'; // Your default favicon

  if (!document.querySelector("link[rel*='icon']")) {
    document.head.appendChild(defaultFavicon);
  }
};

// Reset to default when needed
export const resetToDefault = () => {
  document.title = 'Cafe.WebReady24 - Multi-Restaurant Food Ordering';
  setDefaultFavicon();
};